<template>
    <div>
        <button type="button" class="btn btn-default" title="Filters" v-on:click="getFilters(this)">
            <i class="fa fa-filter"></i>
            <span class="badge" style="background-color: #d9534f" :title="`${filterCount} Filter(s) Applied`" v-if="filterCount > 0">{{ filterCount }}</span>
        </button>

        <div style="z-index: 1; padding-top: 12px;" class="VueTables__dropdown-filter" v-if="showFilters">
            <div class="table-filters-padding" v-if="filtersLoaded">
                <slot v-bind:filterData="filterData" v-bind:filters="filters" v-bind:showMoreFilters="showMoreFilters"></slot>
                <hr />

                <div style="margin-top: 20px;">
                    <button type="button" class="btn btn-sm btn-default" v-on:click="closeFilters()">
                        <i class="fa fa-caret-up"></i> Close
                    </button>
                    <!--                    <button type="button" class="btn btn-sm btn-primary" v-on:click="open=true" title="Save the currently applied filters as reusable filter setting">
                            <i class="fa fa-save"></i> Save As
                        </button> -->
                    <button type="button" class="btn btn-sm btn-warning" v-on:click="clearFilters()">
                        <i class="fa fa-times"></i> Clear
                    </button>
                    <button type="button" class="btn btn-sm btn-success" v-on:click="applyFilters()">
                        <i class="fa fa-filter"></i> Apply
                    </button>
                </div>
            </div>
            <div v-else>
                <i class="fa fa-circle-o-notch fa-spin"></i>
            </div>
        </div>

        <modal v-model="open" title="Save Part Filters" ref="modal" id="modal-demo" size="lg" ok-text="Save Filter Configuration" ok-type="success">
            <div class="form-horizontal">
                <div class="form-group">
                    <label class="control-label col-md-3">Filter Name:</label>
                    <div class="col-md-7">
                        <input type="text" name="" class="form-control" placeholder="Enter a Name for this Filter Configuration" />
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label col-md-3">Global <i class="fa fa-question-circle" title="Global Filters can be used by all users."></i>:</label>
                    <div class="col-md-7">
                        <input type="checkbox" name="" />
                    </div>
                </div>
            </div>

            <template slot="footer">
                <button type="button" class="btn btn-sm btn-default" v-on:click="open=false">Cancel</button>
                <button type="button" class="btn btn-sm btn-success" v-on:click="saveFilter()">Save Filter Configuration</button>
            </template>

        </modal>
    </div>
</template>

<script>
export default {
    props: ['filterUrl', 'filters', 'countDecrement', 'showMoreFilters'],

    data: function() {
        return {
            urlFilters: {},
            filterData: {},
            filterCount: 0,
            filtersLoaded: false,
            showFilters: false,
            loading: false,
            open: false,
        }
    },

    watch: {
        filters(newValue, oldValue){
            //Update the count
            this.updateFilterCount();
        }
    },

    methods: {

        updateFilterCount: function() {
            //Reset the count
            this.filterCount = 0;
            var status = false;

            // Loop over objects in this.filters
            for (var obj in this.filters) {

                if (this.filters[obj] == null || this.filters[obj] === '') {
                    continue;
                }

                if (Array.isArray(this.filters[obj])) {
                    if (this.filters[obj].length > 0) {
                        this.filterCount++;
                    }
                    continue;
                }

                if (typeof this.filters[obj] === 'object') {
                    var Empty = true;
                    for (var key in this.filters[obj]) {
                        if (this.filters[obj].hasOwnProperty(key));
                        Empty = false;
                    }
                    if (!Empty) {
                        this.filterCount++;
                    }
                    continue;
                }

                if (typeof this.filters[obj] === 'string' || typeof this.filters[obj] === 'number') {
                    this.filterCount++;
                }
            }
        },

        clearFilters: function() {
            //Reset each
            for (var columnName in this.filters) {
                this.filters[columnName] = '';
            }

            this.$emit('filtersCleared', this.filters);

            //Update the count
            this.updateFilterCount();

            //Close it
            this.closeFilters();
        },

        applyFilters: function() {
            //Send it
            //this.$refs.partTable.getData();
            this.$emit('filtersChanged', this.filters);

            //Update the count
            this.updateFilterCount();

            //Close it
            this.closeFilters(); //Update the state
        },

        closeFilters: function() {
            //Hide the modal
            this.showFilters = false;
        },

        saveFilter: function() {
            //Send it
            this.$http
                .post('filters/save')
                .then(response => {
                    //Set the returned filter in the saved filters
                    this.savedFilters[response.data.table_filter_id] = response.data;
                });
        },

        setUrlFilters(filters){
            //Set it
            this.urlFilters = filters;
        },

        getFilters: function() {
            //Show the modal or container
            this.showFilters = this.showFilters === true ? false : true;

            //Check if the filters are already loaded or if the user is closing it
            if (this.filtersLoaded || this.showFilters === false || this.filterUrl == null)
            {
                //Make sure filters loading is true
                this.filtersLoaded = true;

                //Stop here
                return;
            }

            //Send it
            this.$http
                .get(this.filterUrl, this.urlFilters)
                .then(response => {
                    //Emit
                    //this.$emit('filterDataLoaded', response.data);
                    this.filterData = response.data;

                    //Set the flag
                    this.filtersLoaded = true;
                });
        },

        reset(){
            //Set the filter data
            this.clearFilters();

            //SEt the data
            this.filterData = {};
            this.filtersLoaded = false;
            this.showFilters = false;
        }
    },

    mounted() {
        //Get the parts
        this.updateFilterCount();
    }
}
</script>
<style>
    .table-filters-padding > div {
        margin-top: .5rem;
    }
</style>